var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "7 7 30 30",
    fill: "none",
    stroke: "#929497",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 13.223a9.033 9.033 0 014 0m-4 17.554a9.033 9.033 0 004 0M13.223 20a9.033 9.033 0 000 4m17.554-4a9.033 9.033 0 010 4M17 14.515A9.05 9.05 0 0014.515 17m0 10A9.05 9.05 0 0017 29.485m10 0A9.05 9.05 0 0029.485 27M27 14.515A9.05 9.05 0 0129.485 17M19 19.667C19 18.194 20.343 17 22 17s3 1.194 3 2.667c0 2.222-3 3.11-3 4.444V25m0 2v-.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgQuestion;